import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/Auth'

export function RequireAuth({ admin = false, children }: { admin?: boolean; children: ReactNode }) {
  const { user } = useAuth()
  const location = useLocation()
  if (user === null) return <p className="py-32 text-center text-slate-400">Chargement…</p>
  if (!user) {
    if (admin) return <Navigate to="/admin/connexion" replace />
    return <Navigate to={`/connexion?next=${encodeURIComponent(location.pathname + location.search)}`} replace />
  }
  if (admin && user.role !== 'admin') return <Navigate to="/compte" replace />
  return <>{children}</>
}
